import { Navigate, RouteObject } from "react-router";
import { LabsRoute } from "./labs/labs-route";
import { LabListRoute } from "./labs/lab-list-route";
import { LabRoute } from "./labs/[labId]/lab-route";
import { AirMicrobialBaseDataListRoute } from "./air-microbial/air-microbial-base-data-list-route";
import { AirMicrobialBaseDataRoute } from "./air-microbial/[baseDataId]/air-microbial-base-data-route";
import { SurfaceMicrobialBaseDataListRoute } from "./surface-microbial/surface-microbial-base-data-list-route";
import { SurfaceMicrobialBaseDataRoute } from "./surface-microbial/[baseDataId]/surface-microbial-base-data-route";
import { DustDensityBaseDataListRoute } from "./dust-density/dust-density-base-data-list-route";
import { DustDensityBaseDataRoute } from "./dust-density/[baseDataId]/dust-density-base-data-route";
import { WaterBaseDataListRoute } from "./water/water-base-data-list-route";
import { WaterBaseDataRoute } from "./water/[baseDataId]/water-base-data-route";

export const samplesBaseDataRoutes: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="labs" replace />,
  },
  {
    path: "labs",
    element: <LabsRoute />,
    children: [
      {
        index: true,
        element: <LabListRoute />,
      },
      {
        path: ":labId",
        element: <LabRoute />,
      },
    ],
  },
  {
    path: "air-microbial",
    element: <AirMicrobialBaseDataListRoute />,
  },
  {
    path: "air-microbial/:baseDataId",
    element: <AirMicrobialBaseDataRoute />,
  },
  {
    path: "surface-microbial",
    element: <SurfaceMicrobialBaseDataListRoute />,
  },
  {
    path: "surface-microbial/:baseDataId",
    element: <SurfaceMicrobialBaseDataRoute />,
  },
  {
    path: "dust-density",
    element: <DustDensityBaseDataListRoute />,
  },
  {
    path: "dust-density/:baseDataId",
    element: <DustDensityBaseDataRoute />,
  },
  {
    path: "water",
    element: <WaterBaseDataListRoute />,
  },
  {
    path: "water/:baseDataId",
    element: <WaterBaseDataRoute />,
  },
];
